module.exports = __webpack_public_path__ + "img/南方电网.4623e741.png";